"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverListWrapper = exports.getClusterDataFilledLevels = exports.getClusterDataStops = exports.getSvgImage = exports.getSvgImageSrc = exports.IMAGE_SCALE = exports.IMAGE_SIZE = void 0;
var antd_1 = require("antd");
var react_1 = __importDefault(require("react"));
var server_1 = require("react-dom/server");
var styled_components_1 = __importDefault(require("styled-components"));
var types_1 = require("../types");
var index_1 = require("./ClusterMarkers/index");
var utils_1 = require("./utils");
exports.IMAGE_SIZE = 15;
exports.IMAGE_SCALE = 1.4;
var getSvgImageSrc = function (Component) {
    var src = server_1.renderToString(react_1.default.createElement(Component, null)).replaceAll("#", "%23");
    return "data:image/svg+xml;utf8," + src;
};
exports.getSvgImageSrc = getSvgImageSrc;
var getSvgImage = function (Component, w, h) {
    if (w === void 0) { w = 80; }
    if (h === void 0) { h = 80; }
    var svgImage = new Image(w, h);
    svgImage.src = exports.getSvgImageSrc(Component);
    return svgImage;
};
exports.getSvgImage = getSvgImage;
var CircleMap = (_a = {},
    _a[types_1.StopType.COMPLETE_CONTAINER_STOP] = {
        circleFill: "#7CC81B",
        circleStrokeColor: "#7CC81B",
    },
    _a[types_1.StopType.COMPLETE_INQUIRY_STOP] = {
        circleFill: "#D0E989",
        circleStrokeColor: "#D0E989",
    },
    _a[types_1.StopType.CREATED_INQUIRY_EMPTIED] = {
        circleFill: "#FFA940",
        circleStrokeColor: "#FFA940",
    },
    _a[types_1.StopType.CREATED_INQUIRY_NON_EMPTIED] = {
        circleFill: "#FF4D4F",
        circleStrokeColor: "#FF4D4F",
    },
    _a[types_1.StopType.PENDING_CONTAINER_STOP] = {
        circleFill: "#ffffff",
        circleStrokeColor: "#909DA9",
    },
    _a[types_1.StopType.PENDING_INQUIRY_STOP] = {
        circleFill: "#ffffff",
        circleStrokeColor: "#FFA940",
    },
    _a[types_1.StopType.CURRENT_CONTAINER_STOP] = {
        circleFill: "#ffffff",
        circleStrokeColor: "#1890FF",
    },
    _a[types_1.StopType.CURRENT_INQUIRY_STOP] = {
        circleFill: "#ffffff",
        circleStrokeColor: "#1890FF",
    },
    _a[types_1.FillType.LOW_FILLED_LEVEL] = {
        circleFill: "#7CC81B",
        circleStrokeColor: "#7CC81B",
    },
    _a[types_1.FillType.MEDIUM_FILLED_LEVEL] = {
        circleFill: "#FFA940",
        circleStrokeColor: "#FFA940",
    },
    _a[types_1.FillType.HIGH_FILLED_LEVEL] = {
        circleFill: "#FF4D4F",
        circleStrokeColor: "#FF4D4F",
    },
    _a[types_1.FillType.STATIC_CONTAINER] = {
        circleFill: "#909DA9",
        circleStrokeColor: "#909DA9",
    },
    _a);
var imagesMap = {
    1: {
        imageComponent: index_1.ClusterMarkerStops,
        sizes: {
            "2": [(35 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "3": [(48 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "4": [(48 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "5": [(62 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "6": [(62 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
        },
        sizesCurrent: {
            "2": [(47 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "3": [(60 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "4": [(60 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "5": [(74 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "6": [(74 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
        },
    },
    2: {
        imageComponent: index_1.ClusterMarkerStops,
        sizes: {
            "2": [(35 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "3": [(48 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "4": [(48 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "5": [(62 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "6": [(62 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
        },
        sizesCurrent: {
            "2": [(47 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "3": [(60 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "4": [(60 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "5": [(74 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "6": [(74 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
        },
    },
    3: {
        imageComponent: index_1.ClusterMarkerStops,
        sizes: {
            "2": [(36 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "3": [(48 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "4": [(48 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "5": [(60 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "6": [(60 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
        },
        sizesCurrent: {
            "2": [(47 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "3": [(60 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "4": [(60 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "5": [(74 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "6": [(74 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
        },
    },
    4: {
        imageComponent: index_1.ClusterMarkerStops,
        sizes: {
            "2": [(40 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "3": [(48 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "4": [(48 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "5": [(62 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "6": [(62 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
        },
        sizesCurrent: {
            "2": [(47 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "3": [(60 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "4": [(60 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "5": [(74 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "6": [(74 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
        },
    },
    5: {
        imageComponent: index_1.ClusterMarkerStops,
        sizes: {
            "2": [(46 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "3": [(48 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "4": [(48 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "5": [(62 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "6": [(62 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
        },
        sizesCurrent: {
            "2": [(47 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "3": [(60 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "4": [(60 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "5": [(74 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "6": [(74 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
        },
    },
    6: {
        imageComponent: index_1.ClusterMarkerStops,
        sizes: {
            "2": [(52 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "3": [(52 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "4": [(52 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "5": [(62 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "6": [(62 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
        },
        sizesCurrent: {
            "2": [(52 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "3": [(60 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "4": [(60 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "5": [(74 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
            "6": [(74 * exports.IMAGE_SCALE).toString(), (39 * exports.IMAGE_SCALE).toString()],
        },
    },
};
var imagesMapFilledLevel = {
    1: {
        imageComponent: index_1.ClusterMarkerFilledLevels,
        sizes: {
            "1": [(25 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "2": [(32 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "3": [(39 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "4": [(39 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
        },
    },
    2: {
        imageComponent: index_1.ClusterMarkerFilledLevels,
        sizes: {
            "1": [(28 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "2": [(32 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "3": [(39 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "4": [(39 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
        },
    },
    3: {
        imageComponent: index_1.ClusterMarkerFilledLevels,
        sizes: {
            "1": [(34 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "2": [(34 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "3": [(39 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "4": [(39 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
        },
    },
    4: {
        imageComponent: index_1.ClusterMarkerFilledLevels,
        sizes: {
            "1": [(40 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "2": [(40 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "3": [(40 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
            "4": [(40 * exports.IMAGE_SCALE).toString(), (37 * exports.IMAGE_SCALE).toString()],
        },
    },
};
var getClusterDataStops = function (stopTypes, digitLength, isCurrent) {
    var _a, _b;
    var circles = stopTypes.map(function (type) {
        return CircleMap[type];
    });
    var size = (_a = imagesMap[utils_1.getLength(circles.length)]) === null || _a === void 0 ? void 0 : _a.sizes[digitLength];
    if (isCurrent) {
        size = imagesMap[utils_1.getLength(circles.length)].sizesCurrent[digitLength];
    }
    var Image = (_b = imagesMap[utils_1.getLength(circles.length)]) === null || _b === void 0 ? void 0 : _b.imageComponent;
    return {
        imgSrc: exports.getSvgImageSrc(function () { return (react_1.default.createElement(Image, { circles: circles, digit: digitLength, stopTypes: stopTypes, hover: false, isCurrent: isCurrent })); }),
        imgSrcHover: exports.getSvgImageSrc(function () { return (react_1.default.createElement(Image, { circles: circles, digit: digitLength, stopTypes: stopTypes, hover: true, isCurrent: isCurrent })); }),
        width: size[0],
        height: size[1],
    };
};
exports.getClusterDataStops = getClusterDataStops;
var getClusterDataFilledLevels = function (fillTypes, digitLength) {
    var _a, _b;
    var circles = fillTypes.map(function (type) {
        return CircleMap[type];
    });
    var size = (_a = imagesMapFilledLevel[utils_1.getLength(circles.length)]) === null || _a === void 0 ? void 0 : _a.sizes[digitLength];
    var Image = (_b = imagesMapFilledLevel[utils_1.getLength(circles.length)]) === null || _b === void 0 ? void 0 : _b.imageComponent;
    return {
        imgSrc: exports.getSvgImageSrc(function () { return (react_1.default.createElement(Image, { circles: circles, digit: digitLength, fillTypes: fillTypes, hover: false })); }),
        imgSrcHover: exports.getSvgImageSrc(function () { return (react_1.default.createElement(Image, { circles: circles, digit: digitLength, fillTypes: fillTypes, hover: true })); }),
        width: size[0],
        height: size[1],
    };
};
exports.getClusterDataFilledLevels = getClusterDataFilledLevels;
exports.PopoverListWrapper = styled_components_1.default(antd_1.List)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    height: auto;\n    max-height: 400px;\n    overflow: auto;\n    /* width */\n    ::-webkit-scrollbar {\n      width: 8px;\n    }\n    /* Track */\n    ::-webkit-scrollbar-track {\n      background: white;\n      border-radius: 15px;\n    }\n    /* Handle */\n\n    ::-webkit-scrollbar-thumb {\n      background: #bcbfc2;\n      border-radius: 15px;\n    }\n    /* Handle on hover */\n    ::-webkit-scrollbar-thumb:hover {\n      background: #bcbfc2;\n    }\n  }\n"], ["\n  &&& {\n    height: auto;\n    max-height: 400px;\n    overflow: auto;\n    /* width */\n    ::-webkit-scrollbar {\n      width: 8px;\n    }\n    /* Track */\n    ::-webkit-scrollbar-track {\n      background: white;\n      border-radius: 15px;\n    }\n    /* Handle */\n\n    ::-webkit-scrollbar-thumb {\n      background: #bcbfc2;\n      border-radius: 15px;\n    }\n    /* Handle on hover */\n    ::-webkit-scrollbar-thumb:hover {\n      background: #bcbfc2;\n    }\n  }\n"])));
var templateObject_1;
